import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { Observable } from 'rxjs';
import {
  CloudAccountActivationEntity,
  CloudAccountStatusEntity,
} from '../configs/entity.config';

@Injectable({
  providedIn: 'root',
})
export class CloudService {
  constructor() {}

  getAccountStatus(payload: any): Observable<IEntity<any>> {
    return EntityManager.getEntity(CloudAccountStatusEntity, {
      serviceId: payload.serviceId,
    });
  }

  activateAccount(payload: any) {
    const iEntity = EntityManager.createEntity(CloudAccountActivationEntity, {
      serviceId: payload.serviceId,
    });
    return EntityManager.updateEntity(iEntity);
  }
}
